<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M5.333 12c-.366 0-.68-.13-.941-.392A1.284 1.284 0 0 1 4 10.667v-8c0-.367.13-.68.392-.942.26-.261.575-.392.941-.392h8c.367 0 .68.13.942.392.261.261.392.575.392.942v8c0 .366-.131.68-.392.941a1.284 1.284 0 0 1-.942.392h-8Zm0-1.333h8v-8h-8v8Zm-2.666 4a1.28 1.28 0 0 1-.942-.392 1.284 1.284 0 0 1-.392-.942V4h1.334v9.333H12v1.334H2.667Z"
        />
        <path
            fill="currentColor"
            d="M9 8.333H7.667a1.61 1.61 0 0 1-1.18-.487A1.606 1.606 0 0 1 6 6.666c0-.46.162-.854.487-1.179A1.606 1.606 0 0 1 7.667 5H9v.667H7.667a.964.964 0 0 0-.709.291.964.964 0 0 0-.291.709c0 .277.097.514.291.708.195.194.43.292.709.292H9v.666ZM8 7v-.667h2.667V7H8Zm1.667 1.333v-.666H11a.964.964 0 0 0 .708-.292.964.964 0 0 0 .292-.708.964.964 0 0 0-.292-.709.964.964 0 0 0-.708-.291H9.667V5H11c.461 0 .854.162 1.18.487.324.325.487.719.487 1.18 0 .46-.163.854-.488 1.179A1.606 1.606 0 0 1 11 8.333H9.667Z"
        />
    </svg>
</template>

<script setup lang="ts">
type CopyLinkIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<CopyLinkIconProps>();
</script>
